import { Component, OnInit, HostListener } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "../../../environments/environment";
import { CommonHttpService } from "../commonHttp.service";
import { LoaderService } from "../../_shared/services/loader.service";
import { AddToCartService } from "../../_shared/services/add-to-cart.service";
import { isNumeric } from "rxjs/util/isNumeric";

@Component({
  selector: "app-category",
  templateUrl: "./category.component.html",
  styleUrls: ["./category.component.css"],
})
export class CategoryComponent implements OnInit {
  relevance: any = 0;
  paramsId: number;
  slugpara: any;
  id: any;
  arrowkeyLocation = 0;
  searchbox: string;
  bname: string;
  baseUrl: any = environment.apiUrl;
  imageUrl: any = environment.imageUrl;
  products: any = [];
  allProducts: any = [];
  brands: any = [];
  sendData: any = {};
  isListEnd: boolean = false;
  offset: number = 0;
  offsetLoader: boolean = false;
  offsetResFetched: boolean = true;
  brandIds: any = [];
  sortType: any = "PriceHigh";
  cart: any = {};
  cartItems: any = [];
  availableQuantity: number;
  quantityError: boolean = false;
  showLoaderProduct: boolean = false;
  searchresult: any = []
  constructor(
    private service: CommonHttpService,
    private addToCartService: AddToCartService,
    private router: Router,
    private route: ActivatedRoute,
    private loaderService: LoaderService
  ) {
    this.addToCartService.isCartChanged.subscribe((flag) => {
      this.cart = JSON.parse(localStorage.getItem("cart"));
      this.cartItems = this.cart != null ? this.cart.EcartItem : [];
      this.updateCart();
    });
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.cart = JSON.parse(localStorage.getItem("cart"));
    this.cartItems = this.cart != null ? this.cart.EcartItem : [];
    this.route.params.subscribe((params) => {
      this.paramsId = params["id"];
      // let numValue = this.paramsId;
      // console.log(typeof numValue);
    });
    var val = this.paramsId;
    if (isNumeric(val)) {
      console.log("number");
      this.service
        .get(this.baseUrl + "CategoryAPI/GetSlugByCategoryId/" + this.paramsId)
        .subscribe(
          (data) => {
            console.log(data);
            this.slugpara = data;
            console.log(this.slugpara);
            window.location.href = "category/" + this.slugpara;
          },
          (error) => { }
        );
    } else {
      this.service
        .get(
          this.baseUrl +
          "ProductMasterAPI/GetBrandListByCategorySlug/" +
          this.paramsId
        )
        .subscribe(
          (data) => {
            this.brands = data;
            console.log(this.brands);
          },
          (error) => { }
        );

      setTimeout(() => {
        this.loadData(1);
      }, 1);
    }
  }

  loadData(flag) {
    this.offsetLoader = false;
    flag == 1 ? (this.showLoaderProduct = true) : (this.offsetLoader = true);
    if (this.brandIds.length == 0) {
      this.sendData = {
        Slug: this.paramsId,
        BrndIds: null,
        Limit: 12,
        Offset: this.offset,
        SortType: this.sortType,
      };
    } else {
      this.sendData = {
        Slug: this.paramsId,
        BrndIds: this.brandIds,
        Limit: 12,
        Offset: this.offset,
        SortType: this.sortType,
      };
    }

    this.service
      .create(
        this.baseUrl + "ProductAPI/GetProductByCategorySlug",
        this.sendData
      )
      .subscribe(
        (data) => {
          console.log(data);
          this.offsetResFetched = true;
          this.offsetLoader = false;
          this.offset = this.offset + 12;
          this.products = data;
          for (var i = 0; i < this.products.length; i++) {
            this.allProducts.push(this.products[i]);
          }
          console.log(this.allProducts);
          if (this.products.length == 0) {
            this.isListEnd = true;
          }
          this.updateCart();
          this.showLoaderProduct = false;
        },
        (error) => {
          this.showLoaderProduct = false;
        }
      );
  }
  showResults = function () {
    if (this.searchbox != undefined) {
      if (this.searchbox.length >= 3) {
        this.service
          .get(
            this.baseUrl +
            "ProductMasterAPI/GetBrandsByCategorySlugSearch/" +
            "?slug=" +
            this.paramsId +
            "&Name=" +
            this.searchbox
          )
          .subscribe(
            (data) => {
              this.searchresult = data;
              console.log(this.searchresult);
              this.bname = this.searchresult[0].brandName;
              console.log(this.bname);
              this.bid = this.searchresult[0].brandId;
              console.log(this.bid);
              console.log(this.searchbox);
            },
            (error) => { }
          );
      } else if (this.searchbox.length <= 3) {
        this.searchresult = [];
        this.arrowkeyLocation = -1;
        // this.searchbox = null;
        console.log(this.searchbox);
        console.log(this.bname.lenght);
        if (this.bname != null && this.bname.lenght == undefined) {
          //  window.location.href = "category/" + this.paramsId;
          var pos = this.brandIds.indexOf(this.bid);
          this.brandIds.splice(pos, 1);
          this.offset = 0;
          this.isListEnd = false;
          this.allProducts = [];
          this.loadData(1);
        }
      }
    }
  };
  changeStyle = function (i) {
    this.arrowkeyLocation = i;
  };
  goToProductCat = function (id, type, val) {
    this.searchbox = "";
    console.log(val);
    console.log(id);
    console.log(type);
    if (type == "Category") {
      window.location.href = "category/" + id;
      // this.router.navigate(['/category', id]);
    } else if (type == "Product") {
      window.location.href = "product/" + id;
    }
    console.log(id);
  };

  // keyDown(event: KeyboardEvent) {
  //   // var activeElemnts = document.getElementsByClassName("active");
  //   switch (event.keyCode) {
  //     case 38: // this is the ascii of arrow up
  //       if (this.arrowkeyLocation != 0) {
  //         this.arrowkeyLocation--;
  //       }
  //       break;
  //     case 40: // this is the ascii of arrow down
  //       this.arrowkeyLocation++;
  //       break;
  //     case 13:

  //     // if (activeElemnts.length > 0) {

  //     // this.goToProductCat(activeElemnts[0].attributes["activeId"].nodeValue, activeElemnts[0].attributes["activeType"].nodeValue, activeElemnts[0].textContent);

  //     //}
  //   }
  // }
  showSearchResults = function () {
    if (this.searchbox != undefined) {
      if (this.searchbox.length >= 3) {
        this.service
          .get(
            this.baseUrl +
            "ProductMasterAPI/GetBrandsByCategorySlugSearch/" +
            "?slug=" +
            this.paramsId +
            "&Name=" +
            this.searchbox
          )
          .subscribe(
            (data) => {
              this.searchresult = data;
              console.log(this.searchresult);
              this.bname = this.searchresult[0].brandName;
              console.log(this.bname);
              console.log(this.searchbox);
            },
            (error) => { }
          );
      } else if (this.searchbox.length <= 3) {
        this.searchresult = [];
        this.arrowkeyLocation = -1;
        // this.searchbox = null;
        console.log(this.searchbox);
        console.log(this.bname.lenght);
        if (this.bname != null && this.bname.lenght == undefined) {
          window.location.href = "category/" + this.paramsId;
        }
      }
    }
  };
  hideresult = function () {
    this.searchresult = [];
  };

  add_serch_filter = function (checkstatus, itemId) {
    console.log(checkstatus);

    console.log(itemId);
    if (checkstatus != undefined) {
      this.brandIds.push(itemId);
      this.offset = 0;
      this.isListEnd = false;
      this.allProducts = [];
      this.loadData(1);
    } else {
      var pos = this.brandIds.indexOf(itemId);
      this.brandIds.splice(pos, 1);
      this.offset = 0;
      this.isListEnd = false;
      this.allProducts = [];
      this.loadData(1);
    }
  };
  add_remove_filter = function (checkstatus, itemId) {
    console.log(itemId);
    console.log(checkstatus);
    if (checkstatus.target.checked) {
      this.brandIds.push(itemId);
      this.offset = 0;
      this.isListEnd = false;
      this.allProducts = [];
      this.loadData(1);
    } else {
      var pos = this.brandIds.indexOf(itemId);
      this.brandIds.splice(pos, 1);
      this.offset = 0;
      this.isListEnd = false;
      this.allProducts = [];
      this.loadData(1);
    }
  };

  sort_order = function () {
    console.log(this.relevance);
    if (this.relevance == 1) {
      this.sortType = "PriceLow";
      this.allProducts = [];
      this.offset = 0;
      this.isListEnd = false;
      this.loadData(1);
    } else if (this.relevance == 2) {
      this.sortType = "PriceHigh";
      this.allProducts = [];
      this.offset = 0;
      this.isListEnd = false;
      this.loadData(1);
    } else if (this.relevance == 3) {
      this.sortType = "PriceHigh";
      this.allProducts = [];
      this.offset = 0;
      this.isListEnd = false;
      this.loadData(1);
    }
  };

  addToCart(product) {
    product.cartQuantity = 1;
    this.addToCartService.addToCart(product);
    console.log(this.allProducts);
  }

  updateCart() {
    for (var i = 0; i < this.allProducts.length; i++) {
      this.allProducts[i].isAddedToCart = false;
    }
    for (var i = 0; i < this.cartItems.length; i++) {
      for (var j = 0; j < this.allProducts.length; j++) {
        if (this.cartItems[i].ProductId == this.allProducts[j].productId) {
          this.allProducts[j].isAddedToCart = true;
          this.allProducts[j].cartQuantity = this.cartItems[i].Quantity;
        }
      }
    }
  }

  substractquantity(product, cartQuantity, i) {
    this.quantityError = false;
    product.cartQuantity = cartQuantity - 1;
    this.addToCartService.addToCart(product);
  }
  addQuantity(product, cartQuantity, i) {
    if (cartQuantity + 1 > product.totalStock) {
      this.quantityError = true;
      this.availableQuantity = product.totalStock;
      product.cartQuantity = cartQuantity;
    } else {
      this.quantityError = false;
      product.cartQuantity = cartQuantity + 1;
    }
    this.addToCartService.addToCart(product);
  }

  onQuantityChange(product, cartQuantity, i) {
    if (cartQuantity > product.totalStock) {
      this.quantityError = true;
      this.availableQuantity = product.totalStock;
      product.cartQuantity = product.totalStock;
    } else {
      this.quantityError = false;
      product.cartQuantity = cartQuantity;
    }
    this.addToCartService.addToCart(product);
  }

  @HostListener("window:scroll", [])
  onScroll(): void {
    if (
      window.innerHeight + window.scrollY >= document.body.offsetHeight - 500 &&
      this.allProducts.length > 0
    ) {
      if (!this.isListEnd && this.offsetResFetched) {
        console.log("a");
        this.offsetResFetched = false;
        this.loadData(2);
      }
    }
  }
}



// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/category/category.component.ts